// extracted by mini-css-extract-plugin
module.exports = {"player":"PlayerEntry_player__4pHcX","details_opener":"PlayerEntry_details_opener__Clt2U","current":"PlayerEntry_current__0QbEW"};